// extracted by mini-css-extract-plugin
module.exports = {"category_box":"SelectCategory_category_box__eexTB","category_title":"SelectCategory_category_title__3cehc","main_category":"SelectCategory_main_category__2J_3Z"};